import { isSuperUser } from "../components/content/axiosConfig";

/** Pond dropdown options for graph/table filters. */
export async function fetchPondDropdownOptions(axiosInstance, userDetails, fisherWide) {
  if (isSuperUser(userDetails)) {
    const response = await axiosInstance.get("api/Pond/GetAllPonds", {
      params: { search: "" },
    });
    const list = Array.isArray(response.data) ? response.data : response.data?.data || [];
    return list.map((pond) => ({
      label: pond.FisherName ? `${pond.Name} (${pond.FisherName})` : pond.Name,
      value: pond.id,
      fisherId: pond.FisherID,
    }));
  }

  const FisherID = userDetails.FisherID;
  if (!FisherID) return [];

  let response;
  if (fisherWide) {
    response = await axiosInstance.get(`api/Pond/GetAllPond/${FisherID}`);
  } else {
    response = await axiosInstance.get(`api/Pond/GetAllPondsByStaff/${userDetails.id}`, {
      params: { fisherID: FisherID },
    });
  }

  return (response.data || []).map((pond) => ({
    label: pond.Name,
    value: pond.id,
    fisherId: FisherID,
  }));
}

/** Resolve FisherID for API calls that require it (super users derive from pond/detail). */
export function resolveFisherId(userDetails, contextFisherId) {
  if (isSuperUser(userDetails)) {
    return contextFisherId ?? null;
  }
  return userDetails.FisherID;
}
